import React from "react";
import ReactDOM from "react-dom";

import "@/config";

import ApplicationArea from "@/components/ApplicationArea";
import offlineListener from "@/services/offline-listener";
import ConfigProvider from 'antd/lib/config-provider';
import koKR from 'antd/lib/locale/ko_KR';

import moment from "moment";
import "moment/locale/ko";
moment.locale("ko");

ReactDOM.render(
  <ConfigProvider locale={koKR}> {/* ConfigProvider로 전체 애플리케이션을 감싸주고 영어 로케일을 설정합니다. */}
    <ApplicationArea />
  </ConfigProvider>,	
  document.getElementById("application-root"), () => {
    offlineListener.init();
});
